import { PasswordInput } from '@mantine/core'

export default {
  PasswordInput: PasswordInput.extend({
    styles: (_theme, params) => ({
      input: {
        borderRadius: '8px',
        cursor: params.readOnly ? 'not-allowed' : undefined,
      },
    }),
  }),
}
